import { iconMapping, type IMovementTypeGroup, TMovementType, type TMovementTypeGroup } from '../types';
import type { MovementTypeGroup, MovementTypesResponse } from '@/shared/api/experience';

export const mapMovementTypeGroup = (
  group: MovementTypeGroup,
  groupMap: MovementTypesResponse['movement_type_group_map'],
): IMovementTypeGroup | null => {
  if (!group.str || !groupMap) {
    return null;
  }

  return {
    str: group.str as TMovementTypeGroup,
    label: group.label,
    iconName: iconMapping[group.str as TMovementType & TMovementTypeGroup] || null,
    types: (groupMap[group.str] || []).filter((type): type is TMovementType => type in TMovementType),
    isSelected: false,
  };
};
